/* 取材・メディアの方へ（2026-10-06）。
   ・表紙のテロップ：テロップが見えたら1本ずつ出す（動きを減らす設定・IntersectionObserver のない端末では、最初から出たまま）
   ・台本をコピー／メールアドレスをコピー：クリップボードに写す。写せない端末ではボタンを出さない。結果は読み上げ用の status にも書く
   ・企画のネタ：横送りの「← →」と「いま何枚目か」（PCは並べるので CSS で隠す）。端でも disabled にせず aria-disabled（フォーカスが外れないように）
   ・目次：ページにない章へのリンクは隠す。テーマエディタでブロックを選んだら、たたんだ一覧を開き、横送りをその札まで送る
   いくつかの章が同じファイルを読み込むので、最初の1回だけ動かす（window.__kzPress） */
(() => {
  if (window.__kzPress) return;
  window.__kzPress = true;
  const reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  const telop = () => {
    document.querySelectorAll('[data-kzp-cover]').forEach((cover) => {
      if (cover.dataset.kzpReady) return;
      cover.dataset.kzpReady = '1';
      const list = cover.querySelector('.kzp-telop');
      if (!list || reduce || !('IntersectionObserver' in window)) return;
      cover.classList.add('is-telop');
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          cover.classList.add('is-on');
          io.disconnect();
        }
      }, { threshold: 0.2 });
      io.observe(list);
      window.addEventListener('beforeprint', () => cover.classList.add('is-on'), { once: true });
    });
  };

  const hasClipboard = () => !!(navigator.clipboard && window.isSecureContext);
  const canExec = () => !!(document.queryCommandSupported && document.queryCommandSupported('copy'));
  /* Clipboard API が無いときの予備（同期で呼ぶ。iOS でも選べるよう、readonly にせず 16px で選ぶ） */
  const execCopy = (text) => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.contentEditable = 'true';
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px;';
    document.body.appendChild(ta);
    let ok = false;
    try {
      ta.focus({ preventScroll: true });
      ta.setSelectionRange(0, ta.value.length);
      ok = document.execCommand('copy');
    } catch (e) { ok = false; }
    ta.remove();
    return ok;
  };
  const writeText = (text) => {
    if (!hasClipboard()) return Promise.resolve(execCopy(text));
    return navigator.clipboard.writeText(text).then(() => true, () => (canExec() ? execCopy(text) : false));
  };
  /* 台本：題と「欄名：中身」を1行ずつ */
  const daihonText = (btn) => {
    const box = btn.closest('[data-kzp-daihon]');
    if (!box) return '';
    const name = box.querySelector('.kzp-daihon__name');
    const rows = [...box.querySelectorAll('.kzp-daihon__row')].map((r) => {
      const dt = r.querySelector('dt');
      const dd = r.querySelector('dd');
      const body = dd ? (dd.dataset.kzpText || dd.textContent) : '';
      return `${dt ? dt.textContent.trim() : ''}：${body.trim()}`;
    });
    return [name ? name.textContent.trim() : '', ...rows].filter(Boolean).join('\n');
  };
  const copy = () => {
    if (!hasClipboard() && !canExec()) return;
    document.querySelectorAll('[data-kzp-copy]').forEach((btn) => {
      if (btn.dataset.kzpReady) return;
      btn.dataset.kzpReady = '1';
      const label = btn.querySelector('[data-kzp-copy-label]');
      const label0 = label ? label.textContent : '';
      const status = btn.parentElement && btn.parentElement.querySelector('[data-kzp-copy-status]');
      btn.hidden = false;
      btn.addEventListener('click', () => {
        const key = btn.dataset.kzpCopy;
        const text = key === 'daihon' ? daihonText(btn) : key;
        (text ? writeText(text) : Promise.resolve(false)).then((ok) => {
          const msg = ok ? 'コピーしました' : 'コピーできませんでした';
          if (label) label.textContent = msg;
          if (status) status.textContent = msg;
          btn.classList.toggle('is-done', ok);
          clearTimeout(btn.kzpTimer);
          btn.kzpTimer = setTimeout(() => {
            if (label) label.textContent = label0;
            if (status) status.textContent = '';
            btn.classList.remove('is-done');
          }, 2400);
        });
      });
    });
  };

  const rail = () => {
    document.querySelectorAll('[data-kzp-rail]').forEach((box) => {
      if (box.dataset.kzpReady) return;
      const track = box.querySelector('[data-kzp-track]');
      if (!track || !track.children.length) return;
      box.dataset.kzpReady = '1';
      const prev = box.querySelector('[data-kzp-prev]');
      const next = box.querySelector('[data-kzp-next]');
      const now = box.querySelector('[data-kzp-now]');
      const items = [...track.children];
      const step = () => (items[1] ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth) || 1;
      const off = (b, v) => { if (b) b.setAttribute('aria-disabled', v ? 'true' : 'false'); };
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        const can = max > 0;
        /* PC（並べるとき）は横に送れないので、タブで止まらない・「横に送れます」と言わない */
        track.tabIndex = can ? 0 : -1;
        track.setAttribute('aria-label', can ? '企画のネタ（横に送れます）' : '企画のネタ');
        /* 全部見えている札の番号（タブレットは「5–6」のように2枚） */
        const tr = track.getBoundingClientRect();
        const seen = items.map((li, k) => {
          const b = li.getBoundingClientRect();
          return (b.left >= tr.left - 2 && b.right <= tr.right + 2) ? k + 1 : 0;
        }).filter(Boolean);
        if (now) now.textContent = seen.length > 1 ? `${seen[0]}–${seen[seen.length - 1]}` : String(seen[0] || Math.min(items.length, Math.round(track.scrollLeft / step()) + 1));
        off(prev, track.scrollLeft <= 2);
        off(next, !can || track.scrollLeft >= max);
      };
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });
      const go = (btn, d) => {
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        track.scrollBy({ left: d * step(), behavior: reduce ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', () => go(prev, -1));
      if (next) next.addEventListener('click', () => go(next, 1));
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  };

  /* 目次：このページにない章へのリンクは隠す（エディタで章を消したとき） */
  const toc = () => {
    document.querySelectorAll('.kzp-cover .kac__toc a[href^="#"]').forEach((a) => {
      const li = a.closest('li');
      if (li) li.hidden = !document.querySelector(a.getAttribute('href'));
    });
  };

  const run = () => { telop(); copy(); rail(); toc(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:unload', () => setTimeout(toc, 0));
  /* テーマエディタ：選んだブロックが見えるように */
  document.addEventListener('shopify:block:select', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const d = t.closest('details');
    if (d) d.open = true;
    const tr = t.closest('[data-kzp-track]');
    if (tr && tr.firstElementChild) tr.scrollTo({ left: t.offsetLeft - tr.firstElementChild.offsetLeft });
  });
})();
